import React, { useState } from "react";
import KuikaCheckboxGroup from "../../../../ui-kit/kuika-checkbox-group/kuika-checkbox-group";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

interface ICheckboxGroupOption {
  label: string;
  value: string;
  disabled?: boolean;
  description?: string;
}

const OPTIONS: ICheckboxGroupOption[] = [
  { label: "React", value: "react" },
  { label: "Vue", value: "vue" },
  { label: "Angular", value: "angular" },
  { label: "Svelte", value: "svelte", disabled: true }
];

interface IStatefulProps {
  initial?: string[];
  direction?: "horizontal" | "vertical";
  disabled?: boolean;
}

const Stateful: React.FC<IStatefulProps> = ({ initial = [], ...rest }) => {
  const [value, setValue] = useState<string[]>(initial);
  return <KuikaCheckboxGroup options={OPTIONS} value={value} onChange={setValue} {...rest} />;
};

export const CheckboxGroupStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Checkbox Group"
      componentName="KuikaCheckboxGroup"
      sourcePath="ui-kit/kuika-checkbox-group"
      description="Multi-select cluster of checkboxes. Honours per-option disabled flags and a group-wide disabled override."
    >
      <SpecRow label="Vertical (default)" align="start">
        <Stateful direction="vertical" initial={["react"]} />
      </SpecRow>
      <SpecRow label="Horizontal" align="start">
        <Stateful direction="horizontal" initial={["react", "vue"]} />
      </SpecRow>
      <SpecRow label="Group-wide disabled" align="start">
        <Stateful disabled initial={["react"]} />
      </SpecRow>
      <SpecRow label="Per-option disabled" caption="Svelte is locked by option.disabled" align="start">
        <Stateful initial={["react"]} />
      </SpecRow>
    </ShowcaseFrame>
  );
};
